exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".kit-modal .nav-tabs .nav-item {\n  width: 33.333333%;\n}\n\n.kit-modal .radio {\n  padding-top: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/kit/kit.component.css
// module id = 984
// module chunks = 1